// src/Presentation/Components/AboutUs/WhatWeDo.tsx
import React, { JSX } from "react";
import { motion } from "framer-motion";
import styles from "./Aboutus.module.css";
import { useMotion } from "../../../Logic/Functions/Hooks/useMotion";
import type { WhatWeDoProps } from "@model/Aboutus.model";
import SoftwareIcon from "Utils/Assets/SVGs/SoftwareIcon";
import HardwareIcon from "Utils/Assets/SVGs/HardwareIcon";
import LabIcon from "Utils/Assets/SVGs/SystemIntegrationIcon";
import CategoryOffer from "./CategoryOffer";

const iconMap: Record<string, JSX.Element> = {
  software: <SoftwareIcon width={64} height={64} color="#fff" />,
  hardware: <HardwareIcon width={64} height={64} color="#fff" />,
  system:      <LabIcon      width={64} height={64} color="#fff" />,
};

const WhatWeDo: React.FC<WhatWeDoProps> = ({
  data,
  sectionClassName = "",
  gridClassName = "",
  cardClassName = "",
  once = false,
  triggerAmount = 0.2,
}) => {
  const { slideFade, containerStagger } = useMotion();

  return (
    <section
      className={`${styles.wedoSection} ${sectionClassName}`.trim()}
      data-testid="what-we-do"
    >
    
      <motion.h2
        className={styles.wedoHeading}
        data-testid="what-we-do-heading"
        variants={slideFade("left", 0)}
        initial="hidden"
        whileInView="show"
        viewport={{ once, amount: triggerAmount }}
      >
        {data.title}
      </motion.h2>

      {data.subtitle && (
        <motion.p
          className={styles.wedoSub}
          data-testid="what-we-do-subtitle"
          variants={slideFade("right", 0.05)}
          initial="hidden"
          whileInView="show"
          viewport={{ once, amount: triggerAmount }}
        >
          {data.subtitle}
        </motion.p>
      )}

     
      <motion.div
        className={`${styles.wedoCatGrid} ${gridClassName}`.trim()}
        data-testid="what-we-do-grid"
        variants={containerStagger(0.12)}
        initial="hidden"
        whileInView="show"
        viewport={{ once, amount: triggerAmount }}
      >
        {data.items.map((it, i) => {
          const icon = it.iconKey ? iconMap[it.iconKey] : undefined;

          return (
            <motion.article
              key={`${it.title}-${i}`}
              variants={slideFade("up", 0.03 * i)}
              className={cardClassName || styles.wedoCard}
              data-testid={`what-we-do-card-${i}`}
            >
              <CategoryOffer
                title={it.title}
                description={it.description}
                icon={icon}
                imageSrc={!icon ? it.imageSrc : undefined}
              />
            </motion.article>
          );
        })}
      </motion.div>
    </section>
  );
};

export default WhatWeDo;
